import React, { useMemo } from 'react';
import { cn } from '../../utils/cn';
import { diffLineChunks } from '../../utils/neoAiTextDiff';

const chunkClass = {
  equal: 'text-foreground',
  add: 'bg-emerald-500/15 text-emerald-950 dark:text-emerald-100 border-l-2 border-emerald-500 pl-2 -ml-0.5',
  remove:
    'bg-red-500/12 text-red-950 dark:text-red-100 line-through decoration-red-500/70 border-l-2 border-red-500 pl-2 -ml-0.5',
};

function NeoAiDiffPreview({ before, after, className, focused = false }) {
  const chunks = useMemo(() => diffLineChunks(before, after), [before, after]);

  const hasChanges = chunks.some((c) => c.type !== 'equal');

  if (!hasChanges && !before && !after) {
    return (
      <p className="text-sm text-muted-foreground">Nenhum texto para comparar.</p>
    );
  }

  return (
    <div className={cn('space-y-2', className)}>
      {focused ? (
        <p className="text-xs text-muted-foreground">
          Destaque no trecho entre âncoras alterado pela IA (resto do documento omitido).
        </p>
      ) : null}
      <div className="flex flex-wrap gap-3 text-xs">
        <span className="inline-flex items-center gap-1.5">
          <span className="h-2.5 w-2.5 rounded-sm bg-emerald-500/40 border border-emerald-600/40" />
          Adicionado
        </span>
        <span className="inline-flex items-center gap-1.5">
          <span className="h-2.5 w-2.5 rounded-sm bg-red-500/30 border border-red-600/40" />
          Removido
        </span>
      </div>
      <pre
        className="min-h-[120px] max-h-[45vh] overflow-auto rounded-lg border border-border bg-muted/20 p-3 text-xs whitespace-pre-wrap font-mono leading-relaxed"
      >
        {chunks.map((chunk, index) => (
          <span key={`${chunk.type}-${index}`} className={cn(chunkClass[chunk.type])}>
            {chunk.text}
            {index < chunks.length - 1 ? '\n' : ''}
          </span>
        ))}
      </pre>
    </div>
  );
}

export default NeoAiDiffPreview;
